import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/img/home/solution/en_home_goldcircle.png'
import _imports_1 from '../../../public/img/home/fdkeji.jpg'
import _imports_2 from '../../../public/img/home/weix.png'


const _withScopeId = n => (_pushScopeId("data-v-3d919999"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "footer-banner"
}
const _hoisted_2 = { class: "ban-con" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"display":"flex","align-items":"center"} }, [
  /*#__PURE__*/_createElementVNode("a", { style: {"color":"rgba(0,0,0,1)","font-weight":"700"} }, "Consulting Products&Services and Solutions"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"width":"6%","margin":"12px 0px 0px -14px"},
    alt: ""
  })
], -1))
const _hoisted_4 = {
  class: "butt",
  type: "button",
  style: {"color":"rgba(0,0,0,1)"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Online Consultation")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "to_right" }, null, -1))
const _hoisted_7 = { class: "footer-content" }
const _hoisted_8 = { class: "content-top" }
const _hoisted_9 = { class: "item-left" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { style: {"color":"rgba(0,0,0,1)","font-weight":"700","white-space":"nowrap"} }
const _hoisted_12 = { class: "content-bottom" }
const _hoisted_13 = { class: "left" }
const _hoisted_14 = { style: {"color":"rgba(0,0,0,1)","letter-spacing":"-1px"} }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"right\" data-v-3d919999><div style=\"display:flex;\" data-v-3d919999><div style=\"display:flex;flex-direction:column;\" data-v-3d919999><p class=\"title\" style=\"color:rgba(0,0,0,1);font-weight:700;\" data-v-3d919999>Follow Us</p><img src=\"" + _imports_1 + "\" alt=\"分蛋公众号\" data-v-3d919999></div><div style=\"display:flex;flex-direction:column;margin-left:1rem;\" data-v-3d919999><p class=\"title\" style=\"color:rgba(0,0,0,1);font-weight:700;\" data-v-3d919999>Contact Us</p><img src=\"" + _imports_2 + "\" alt=\"分蛋科技\" data-v-3d919999></div></div><p class=\"desc\" style=\"color:rgba(0,0,0,1);letter-spacing:-1px;white-space:nowrap;\" data-v-3d919999>Follow Relevant Industry Information;</p><p style=\"display:flex;align-items:center;\" data-v-3d919999><span class=\"desc\" style=\"color:rgba(0,0,0,1);\" data-v-3d919999>TEL：</span><span class=\"tel\" style=\"color:rgba(0,0,0,1);font-weight:100;font-family:fantasy;\" data-v-3d919999>400-088-0991</span></p></div>", 1)
const _hoisted_16 = { class: "business-license" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font_yy" }, "Business License：", -1))
const _hoisted_18 = {
  key: 0,
  class: "ifShowYY"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "ifshowImg",
  src: "https://www.91fd.com/pc/dist/static/img/magnifyBusinessLicense.3d6965b5.png",
  alt: ""
}, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  style: {"color":"rgba(0,0,0,1)"},
  class: "beian",
  href: "https://beian.miit.gov.cn/#/Integrated/index",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("©Copyright 2023 91fd.com 沪ICP备16030074号")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$route.path === '/')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("button", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: _ctx.dialogVisible,
      onHidden: _ctx.hidden
    }, null, 8, ["visible", "onHidden"]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: index
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                src: require(`../../../public/img/home/quanwei/${item.img}`),
                alt: item.name
              }, null, 8, _hoisted_10),
              _createElementVNode("span", _hoisted_11, _toDisplayString(item.name), 1)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linkList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "left-item",
              key: index
            }, [
              _createElementVNode("p", _hoisted_14, _toDisplayString(item.title), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.links, (l_item, l_index) => {
                return (_openBlock(), _createElementBlock("a", {
                  style: {"color":"rgba(0,0,0,1)"},
                  key: l_index
                }, _toDisplayString(l_item.label), 1))
              }), 128))
            ]))
          }), 128))
        ]),
        _hoisted_15
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("img", {
          class: "img_yy",
          src: "https://www.91fd.com/pc/dist/static/img/magnifyBusinessLicense.3d6965b5.png",
          alt: "",
          onMouseover: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showImage && _ctx.showImage(...args))),
          onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideImage && _ctx.hideImage(...args)))
        }, null, 32)
      ]),
      (_ctx.isImageVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
        : _createCommentVNode("", true),
      _hoisted_21
    ])
  ], 64))
}